/**
 * 环境变量配置辅助函数
 * @since 19/10/16
 */

import store from 'store';
import * as qs from '@fe/common/lib/query-string';

/**
 * 判断 是否显示兔展品牌信息
 */
export function isShowRabbitpre() {
  const userInfo = store.getState().userInfo;
  const { platformConfigInfo = null } = userInfo;
  /**
   * 需要判断在 userInfo 未加载完成时不显示兔展品牌信息 避免logo闪烁
   */
  if (Object.keys(userInfo).length === 0) {
    return false;
  } else {
    if (platformConfigInfo) {
      return !platformConfigInfo.hideRabbitBrandInfo;
    } else {
      return true;
    }
  }
}

/**
 * 是否为兔展运行环境
 */
export function isRabbitpreEnv() {
  const { isRabbitpreEnv } = window.RPCONFIG;
  return isRabbitpreEnv !== false;
}

/**
 * 是否在编辑器嵌套中
 */

export function isInEditorIframe() {
  return (qs.parse(window.location.search) || {}).inEditorIframe === '1';
}
